import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import { reportHourlySalesReport } from 'utils/breadcrumbInfo';
import CardSimple from 'screens/components/basic/CardSimple';
import Header from './Header';
import Pagination from 'screens/components/basic/Pagination';
import { getHourlySalesDateRange, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Grid from 'screens/components/basic/Grid';
import NoDataMsg from 'library/noData';
import PageHeader from 'screens/components/basic/PageHeader';
import {
    Table,
    TableBody,
    TableHead,
    TableCell,
    TableRow,
    TableFooter
} from '@mui/material';
import WithRouter from 'custom/withRouter';
import TableContainer from '@mui/material/TableContainer';
import GenericTable from 'screens/components/advanced/GenericTable';

class HourlySalesDateRange extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date();

        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1), `HourlySalesDateRangeStartDate`);
        this.props.formInput(date, `HourlySalesDateRangeEndDate`);
    }

    getReport = () => {
        let branch = this.props.selectedBranch ? this.props.selectedBranch : this.props.loggedBranch;
        let startDate = this.props.startDate || moment().format("YYYY-MM-DD");
        let endDate = this.props.endDate || moment().format("YYYY-MM-DD");
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        this.props.getHourlySalesDateRange({ branch, startDate, endDate, pageNumber, pageSize });
    }

    downloadReport = () => {
        let branch = this.props.selectedBranch ? this.props.selectedBranch : this.props.loggedBranch;
        let startDate = this.props.startDate;
        let endDate = this.props.endDate;
        let pageNumber = 1;
        let pageSize = 9999;
        if (checkDateRange(startDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/hourlysalesdaterange?branchid=${branch}&startDate=${startDate}&endDate=${endDate}&pageNumber=${pageNumber}&pageSize=${pageSize}`, "HourlySalesDateRange");
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        if (checkDateRange(this.props.startDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }


    getPivotedData = () => {
        let raw = this.props.hourlySalesDateRange && this.props.hourlySalesDateRange.list.length > 0 ? this.props.hourlySalesDateRange.list : [];
        let details = raw.filter(item => item.recordType == "Details")
        let summary = raw.filter(item => item.recordType == "Summary")

        let distinctDates = [...new Set(details.map(item => item.date))]
        let final = []

        distinctDates.map(date => {
            let row = { "Date": moment(date).format('ddd MMMM Do, YYYY') }
            for (let i = 0; i < 24; i++) {
                let found = details.filter(item => item.date == date && item.hour == i)[0]
                row[i] = 
                    <div>
                        <p>${found.hourSales}</p>
                        <p>({found.hourQuantity})</p>
                    </div>
            }

            let thisrowsummary = summary.filter(item => item.date == date)[0]
            row["Total"] =
                    <div>
                        <p>${thisrowsummary != undefined ? thisrowsummary.hourSales : 0}</p>
                        <p>({thisrowsummary != undefined ? thisrowsummary.hourQuantity : 0})</p>
                    </div>

            final.push(row)
        })

        return final
    }

    render() {
        let columns = [{key: "Date", label: "Date"}]
        for (let i = 0; i < 24; i++) {
            columns.push({ key: i, label: i })
        }
        columns.push({ key: "Total", label: "Total Sales (Quantity)"})

        let rows = this.getPivotedData()

        const totalRow = this.props.hourlySalesDateRange && this.props.hourlySalesDateRange.list.length > 0 ? this.props.hourlySalesDateRange.list[0].totalRow : 0;

        return (
            <Grid headerContent={reportHourlySalesReport}>
                <PageHeader
                    title={LOOKUP.report.hourlySalesDateRange.text}
                    description={LOOKUP.report.hourlySalesDateRange.description}
                />
                <Header
                    branchOptions={this.props.brachOptions}
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch}
                />
                {
                    this.state.showBody &&
                    <CardSimple>
                        {
                            this.props.hourlySalesDateRange && this.props.hourlySalesDateRange.list && this.props.hourlySalesDateRange.list.length <= 0 ?
                                <NoDataMsg />
                                :
                                <div className="clearfix">
                                    <div className="text-center list_header">
                                        {this.props.startDate && this.props.endDate ?
                                            <p><i>Date Range:</i> <b>{moment(this.props.startDate).format('MMMM Do, YYYY')} - {moment(this.props.endDate).format('MMMM Do, YYYY')}</b></p>
                                            : ""}
                                    </div>

                                    <GenericTable
                                        className="table_center"
                                        tableBodyClassName="table_center"
                                        multiSelectable={false}
                                        enableSelectAll={false}
                                        displaySelectAll={false}
                                        adjustForCheckbox={false}
                                        displayRowCheckbox={false}
                                        selectable={false}
                                        columns={columns}
                                        rows={rows}
                                        stripedRows={true}
                                    />
                                    <Pagination
                                        length={totalRow}
                                        itemsPerPage={this.state.itemsPerPage}
                                        activePage={this.state.activePage}
                                        onPageChange={this.changePage}
                                    />
                                </div>
                        }
                    </CardSimple>
                }
            </Grid>
        )
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        selectedBranch: state.form.HourlySalesDateRangeBranchOption,
        loggedBranch: state.common.branchId,
        startDate: moment(state.form.HourlySalesDateRangeStartDate).format("YYYY-MM-DD"),
        endDate: moment(state.form.HourlySalesDateRangeEndDate).format("YYYY-MM-DD"),
        hourlySalesDateRange: state.reports.hourlySalesDateRange
    };
};

const mapDispatchToProps = dispatch => {

    return {
        getHourlySalesDateRange: (model) => dispatch(getHourlySalesDateRange(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(HourlySalesDateRange));
